import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useStore } from "@src/utils/hooks";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { usePathname } from "next/navigation";
import { AppSubNav } from "../AppSubNav";

type NavigationTasksProps = {
  variant: "panel" | "page";
};
export const NavigationTasks = observer(function NavigationTasks({
  variant,
}: NavigationTasksProps) {
  const { workspaceStore } = useStore();
  const pathname = usePathname();

  const NAV_ITEMS = computed(() => {
    return workspaceStore.VISIBLE_NAVIGATION.find(
      ({ page }) => page === "tasks",
    )?.subPages;
  }).get();

  if (variant === "page") {
    return (
      <AppSubNav>
        {NAV_ITEMS?.map(({ label, url }) => (
          <NavBar.Item key={url} href={url}>
            {label}
          </NavBar.Item>
        ))}
      </AppSubNav>
    );
  }

  const activeSubpage = NAV_ITEMS?.find(({ url }) => pathname.startsWith(url));

  return (
    <AppSubNav>
      <NavBar.Item active={false} onClick={() => {}}>
        <Trans>Tasks</Trans>
      </NavBar.Item>

      {activeSubpage && (
        <>
          <Icon name="chevron-right" />
          <NavBar.Item href={activeSubpage.url} active={false}>
            {activeSubpage.label}
          </NavBar.Item>
        </>
      )}
    </AppSubNav>
  );
});
